var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { Loader } from "@sequentech/ui-essentials";
import { useTranslation } from "react-i18next";
import { useSettings } from "@/providers/SettingsContextProvider";
import { useCustomCss } from "@/providers/CustomCssContextProvider";
import { useResultsManifest } from "@/providers/ResultsManifestContextProvider";
import { useAuthenticatedResults } from "@/hooks/useAuthenticatedResults";
import { useResultsAuth } from "@/providers/ResultsAuthContextProvider";
import { discoverPublication } from "@/services/publicationDiscovery";
import { resolveSqliteArtifactUrl } from "@/services/artifacts";
import { loadSqliteDatabase, readResultsDataset } from "@/services/sqliteResults";
import { parseResultsManifest } from "@/types/results";
import { publicBucketUrl } from "@/services/urls";
import { manifestCustomCss } from "@/services/customCss";
import { StateMessage } from "@/components/StateMessage";
import { ResultsPageContent } from "@/components/ResultsPageContent";
import { entityClassName } from "@/services/cssClassNames";
import { getElectionEventPresentation } from "@/services/resultsOrdering";
import { ETranslationScope, overwriteTranslations } from "@sequentech/ui-core";
var initialState = {
    loading: true,
    requiresAuth: false,
    authenticatedAccess: false,
};
var loadManifest = function (settingsPublicBucketUrl, discovery) { return __awaiter(void 0, void 0, Promise, function () {
    var manifestPath, manifestUrl, response_1, _a, response, _b;
    var _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                if (discovery.manifest) {
                    return [2 /*return*/, parseResultsManifest(discovery.manifest)];
                }
                if (!!discovery.manifestUrl) return [3 /*break*/, 3];
                manifestPath = (_d = (_c = discovery.indexEntry) === null || _c === void 0 ? void 0 : _c.manifest_public_path) !== null && _d !== void 0 ? _d : (_e = discovery.resolverEntry) === null || _e === void 0 ? void 0 : _e.manifest_public_path;
                manifestUrl = publicBucketUrl(settingsPublicBucketUrl, manifestPath !== null && manifestPath !== void 0 ? manifestPath : undefined);
                if (!manifestUrl) {
                    throw new Error("Publication manifest is not available.");
                }
                return [4 /*yield*/, fetch(manifestUrl, { cache: "no-store" })];
            case 1:
                response_1 = _f.sent();
                if (!response_1.ok) {
                    throw new Error("Unable to load publication manifest: HTTP ".concat(response_1.status));
                }
                _a = parseResultsManifest;
                return [4 /*yield*/, response_1.json()];
            case 2: return [2 /*return*/, _a.apply(void 0, [_f.sent()])];
            case 3: return [4 /*yield*/, fetch(discovery.manifestUrl, { cache: "no-store" })];
            case 4:
                response = _f.sent();
                if (!response.ok) {
                    throw new Error("Unable to load publication manifest: HTTP ".concat(response.status));
                }
                _b = parseResultsManifest;
                return [4 /*yield*/, response.json()];
            case 5: return [2 /*return*/, _b.apply(void 0, [_f.sent()])];
        }
    });
}); };
export var ResultsRoute = function () {
    var _a = useParams(), eeId = _a.eeId, electionId = _a.electionId;
    var globalSettings = useSettings().globalSettings;
    var setCustomCss = useCustomCss().setCustomCss;
    var _b = useResultsManifest(), setManifestLanguageConfig = _b.setManifestLanguageConfig, resetManifestLanguageConfig = _b.resetManifestLanguageConfig;
    var _c = useResultsAuth(), setAuthenticatedSession = _c.setAuthenticatedSession, clearAuthenticatedSession = _c.clearAuthenticatedSession;
    var t = useTranslation().t;
    var _d = useState(initialState), state = _d[0], setState = _d[1];
    var _e = useState(), selectedElectionId = _e[0], setSelectedElectionId = _e[1];
    // An unavailable publication must not erase the identity that completed sign-in:
    // clearing its token would trigger discovery and sign-in again indefinitely.
    var routeKey = JSON.stringify([eeId, electionId]);
    var _f = useState(), authIdentity = _f[0], setAuthIdentity = _f[1];
    var activeIdentity = (authIdentity === null || authIdentity === void 0 ? void 0 : authIdentity.routeKey) === routeKey ? authIdentity : undefined;
    var auth = useAuthenticatedResults(globalSettings, activeIdentity === null || activeIdentity === void 0 ? void 0 : activeIdentity.tenantId, activeIdentity === null || activeIdentity === void 0 ? void 0 : activeIdentity.eventId, state.requiresAuth || state.authenticatedAccess);
    var authToken = activeIdentity ? auth.token : undefined;
    var authTokenRef = useRef(authToken);
    authTokenRef.current = authToken;
    var hasAuthToken = Boolean(authToken);
    var customCss = useMemo(function () {
        var _a, _b, _c;
        return manifestCustomCss(state.manifest, (_c = (_a = electionId !== null && electionId !== void 0 ? electionId : selectedElectionId) !== null && _a !== void 0 ? _a : (_b = state.manifest) === null || _b === void 0 ? void 0 : _b.route_election_id) !== null && _c !== void 0 ? _c : undefined);
    }, [state.manifest, electionId, selectedElectionId]);
    useEffect(function () {
        clearAuthenticatedSession();
        setSelectedElectionId(undefined);
        setAuthIdentity(undefined);
        return function () { return clearAuthenticatedSession(); };
    }, [clearAuthenticatedSession, eeId, electionId]);
    useEffect(function () {
        if (auth.token && auth.userProfile && auth.logout) {
            setAuthenticatedSession({
                userProfile: auth.userProfile,
                logout: auth.logout,
            });
            return;
        }
        if (!state.requiresAuth && !state.authenticatedAccess) {
            clearAuthenticatedSession();
        }
    }, [
        auth.logout,
        auth.token,
        auth.userProfile,
        clearAuthenticatedSession,
        setAuthenticatedSession,
        state.authenticatedAccess,
        state.requiresAuth,
    ]);
    useEffect(function () {
        setCustomCss(customCss);
        return function () { return setCustomCss(""); };
    }, [customCss, setCustomCss]);
    useEffect(function () {
        if (state.manifest) {
            setManifestLanguageConfig(state.manifest);
        }
        else {
            resetManifestLanguageConfig();
        }
        return function () { return resetManifestLanguageConfig(); };
    }, [resetManifestLanguageConfig, setManifestLanguageConfig, state.manifest]);
    useEffect(function () {
        var mounted = true;
        // Do not display wording from the previous publication while a new
        // route is loading or after it fails to load.
        overwriteTranslations(undefined, {
            scope: ETranslationScope.RESULTS_PORTAL,
            changeDefaultLanguage: false,
        });
        var load = function () { return __awaiter(void 0, void 0, void 0, function () {
            var token, discovery, access, manifest, artifactUrl, db, dataset, error_1;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        if (!eeId) {
                            setState({
                                loading: false,
                                authenticatedAccess: false,
                                requiresAuth: false,
                                error: "No election event id was provided.",
                            });
                            return [2 /*return*/];
                        }
                        _l.label = 1;
                    case 1:
                        _l.trys.push([1, 6, , 7]);
                        token = authTokenRef.current;
                        setState(function (current) { return (__assign(__assign({}, current), { loading: true, error: undefined, manifest: undefined, dataset: undefined })); });
                        return [4 /*yield*/, discoverPublication(globalSettings, eeId, electionId, token)];
                    case 2:
                        discovery = _l.sent();
                        if (!discovery) {
                            if (mounted) {
                                setState({
                                    loading: false,
                                    authenticatedAccess: false,
                                    requiresAuth: false,
                                    discovery: null,
                                });
                            }
                            return [2 /*return*/];
                        }
                        access = (_d = (_b = (_a = discovery.resolverEntry) === null || _a === void 0 ? void 0 : _a.access) !== null && _b !== void 0 ? _b : (_c = discovery.indexEntry) === null || _c === void 0 ? void 0 : _c.access) !== null && _d !== void 0 ? _d : "public";
                        if (mounted && access === "authenticated") {
                            setAuthIdentity({
                                routeKey: routeKey,
                                tenantId: (_f = (_e = discovery.resolverEntry) === null || _e === void 0 ? void 0 : _e.tenant_id) !== null && _f !== void 0 ? _f : (_g = discovery.index) === null || _g === void 0 ? void 0 : _g.tenant_id,
                                eventId: (_j = (_h = discovery.resolverEntry) === null || _h === void 0 ? void 0 : _h.election_event_id) !== null && _j !== void 0 ? _j : (_k = discovery.index) === null || _k === void 0 ? void 0 : _k.election_event_id,
                            });
                        }
                        if (access === "authenticated" && !token) {
                            if (mounted) {
                                setState({
                                    loading: false,
                                    authenticatedAccess: true,
                                    requiresAuth: true,
                                    discovery: discovery,
                                });
                            }
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, loadManifest(globalSettings.PUBLIC_BUCKET_URL, discovery)];
                    case 3:
                        manifest = _l.sent();
                        return [4 /*yield*/, resolveSqliteArtifactUrl(globalSettings, manifest, token, electionId)];
                    case 4:
                        artifactUrl = _l.sent();
                        return [4 /*yield*/, loadSqliteDatabase(artifactUrl)];
                    case 5:
                        db = _l.sent();
                        dataset = readResultsDataset(db);
                        db.close();
                        if (mounted) {
                            overwriteTranslations(getElectionEventPresentation(manifest, dataset), {
                                scope: ETranslationScope.RESULTS_PORTAL,
                                changeDefaultLanguage: false,
                            });
                            setState({
                                loading: false,
                                authenticatedAccess: access === "authenticated",
                                requiresAuth: false,
                                discovery: discovery,
                                manifest: manifest,
                                dataset: dataset,
                            });
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        error_1 = _l.sent();
                        if (mounted) {
                            setState({
                                loading: false,
                                authenticatedAccess: false,
                                requiresAuth: false,
                                error: error_1 instanceof Error ? error_1.message : "unexpected_error",
                            });
                        }
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        void load();
        return function () {
            mounted = false;
            overwriteTranslations(undefined, {
                scope: ETranslationScope.RESULTS_PORTAL,
                changeDefaultLanguage: false,
            });
        };
    }, [eeId, electionId, routeKey, globalSettings, hasAuthToken]);
    var content = useMemo(function () {
        var _a;
        if (state.loading || auth.loading) {
            return (_jsx(Box, { className: "seq-results-route__loader", sx: { display: "flex", justifyContent: "center", py: 10 }, children: _jsx(Loader, {}) }));
        }
        if (auth.error) {
            return (_jsx(StateMessage, { className: "seq-results-state-message--sign-in-error", title: t("resultsPortal.state.unexpectedErrorTitle"), message: t("resultsPortal.state.signInErrorMessage") }));
        }
        if (state.error) {
            return (_jsx(StateMessage, { className: "seq-results-state-message--load-error", title: t("resultsPortal.state.unexpectedErrorTitle"), message: t("resultsPortal.state.loadErrorMessage") }));
        }
        if (state.requiresAuth) {
            return (_jsx(StateMessage, { className: "seq-results-state-message--sign-in-required", title: t("resultsPortal.state.signInRequiredTitle"), message: t("resultsPortal.state.signInRequiredMessage") }));
        }
        if (!state.discovery) {
            return (_jsx(StateMessage, { className: "seq-results-state-message--not-published", title: t("resultsPortal.state.notPublishedTitle"), message: t("resultsPortal.state.notPublishedMessage") }));
        }
        if (!state.manifest || !state.dataset) {
            return (_jsx(StateMessage, { className: "seq-results-state-message--missing-artifacts", title: t("resultsPortal.state.notPublishedTitle"), message: t("resultsPortal.state.notPublishedMessage") }));
        }
        if (state.manifest.contests.length === 0) {
            return (_jsx(StateMessage, { className: "seq-results-state-message--empty-publication", title: t("resultsPortal.state.notPublishedTitle"), message: t("resultsPortal.state.notPublishedMessage") }));
        }
        return (_jsx(ResultsPageContent, { manifest: state.manifest, dataset: state.dataset, initialElectionId: (_a = electionId !== null && electionId !== void 0 ? electionId : state.manifest.route_election_id) !== null && _a !== void 0 ? _a : undefined, onElectionChange: setSelectedElectionId }));
    }, [auth.error, auth.loading, state, t]);
    return (_jsx(Box, { className: [
            "seq-results-route",
            entityClassName("route-event", eeId),
            electionId ? entityClassName("route-election", electionId) : null,
        ]
            .filter(Boolean)
            .join(" "), children: content }));
};
